import { createFileRoute } from '@tanstack/react-router';
import { PermissionsPage } from '@/features/settings/ui/PermissionsPage';

export const Route = createFileRoute('/_authenticated/settings/permissions')({ component: PermissionsPage });
